import { gql } from '@apollo/client';

const removeByIdsEventMutation = gql`
  mutation RemoveByIdsEventMutation($ids: [MongoID!]!) {
    removeByIdsEventMutation(ids: $ids) {
      recordIds
      message
      title
    }
  }
`;

export default removeByIdsEventMutation;
